"use strict";

exports.__esModule = true;
exports.AdvancedDataRangeSelector = AdvancedDataRangeSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AdvancedDataRangeSelector(props) {
  var selection = props.value,
    setSelection = props.setProp,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection,
    setFetchOnlyOnSelection = props.setFetchOnlyOnSelection;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("AdvancedDataRangeSelector.dataRange.label", "Data Range"),
    helperText: translate("AdvancedDataRangeSelector.dataRange.helperText", "The data range to show in this table.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    "data-testid": "AdvancedDataRangeSelector.selector",
    value: selection || "",
    onChange: function onChange(e) {
      return setSelection(e.target.value || undefined);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    "data-testid": "AdvancedDataRangeSelector.option.reportingPeriod"
  }, translate("AdvancedDataRangeSelector.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "SELECTION",
    "data-testid": "AdvancedDataRangeSelector.option.selection"
  }, translate("AdvancedDataRangeSelector.dataRange.selection.label", "Selection")))), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "AdvancedDataRangeSelector.fetchDataOnlyOnSelection.label",
    label: translate("AdvancedDataRangeSelector.fetchDataOnlyOnSelection.label", "Fetch data only on selection"),
    checked: fetchDataOnlyOnSelection,
    onChange: function onChange(e) {
      return setFetchOnlyOnSelection(e.target.checked);
    },
    disabled: selection !== "SELECTION"
  }));
}